import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MAX_TICKETS_IN_BASKET } from '@nx-ng/constants/max-tickets-in-basket';

@Component({
  selector: 'nx-ng-basket-item-quantity',
  templateUrl: './basket-item-quantity.component.html',
  styleUrls: ['./basket-item-quantity.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasketItemQuantityComponent {
  @Input() set count(value: number) {
    this.currentCount = value;
  }

  get count(): number {
    return this.currentCount;
  }
  currentCount = 0;

  @Output()
  quantityUpdated: EventEmitter<number> = new EventEmitter<number>();

  handleQuantityUpdated(value: number) {
    this.quantityUpdated.emit(value);
  }

  incrementCurrentCount() {
    this.handleQuantityUpdated(this.currentCount + 1);
  }

  decrementCurrentCount() {
    this.handleQuantityUpdated(this.currentCount - 1);
  }

  get decrementDisabled() {
    return this.currentCount <= 1;
  }

  get incremementDisabled() {
    return this.currentCount >= MAX_TICKETS_IN_BASKET;
  }
}
